/* eslint-disable react/no-array-index-key,no-useless-constructor */
import React from 'react';
import SessionListItem from '../list-item';

class SessionList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { sessionLists } = this.props;

    return (
      <div
        className="login-operations-list"
        style={{ padding: '20px', maxHeight: '1500px', overflow: 'auto' }}
      >
        {
                    sessionLists.length > 0
                      ? sessionLists.map(
                        (session, key) => (
                          <SessionListItem
                            key={key}
                            {...this.props}
                            session={session}
                          />
                        ))
                      : null
                }
      </div>
    );
  }
}

export default SessionList;



// WEBPACK FOOTER //
// ./src/components/session/list/index.js